import { render } from "./Mitgliedschaft.vue?vue&type=template&id=136e4333&scoped=true"
import script from "./Mitgliedschaft.vue?vue&type=script&lang=js"
export * from "./Mitgliedschaft.vue?vue&type=script&lang=js"

import "./Mitgliedschaft.vue?vue&type=style&index=0&id=136e4333&scoped=true&lang=css"

import exportComponent from "/home/jacques/development/kvhbf/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136e4333"]])

export default __exports__